var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIconDates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74968 0C4.37501 0 4.07129 0.319707 4.07129 0.7141V2.14226H5.42804V0.7141C5.42804 0.319707 5.12432 0 4.74968 0Z",
    fill: "#B0BBBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2497 0C13.875 0 13.5713 0.319707 13.5713 0.7141V2.14226H14.928V0.7141C14.9281 0.319707 14.6244 0 14.2497 0Z",
    fill: "#B0BBBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9643 2.14282H14.9286V4.99998C14.9286 5.39448 14.6248 5.71428 14.25 5.71428C13.8752 5.71428 13.5714 5.39448 13.5714 4.99998V2.14282H5.42855V4.99998C5.42855 5.39448 5.12475 5.71428 4.74997 5.71428C4.37519 5.71428 4.07139 5.39448 4.07139 4.99998V2.14282H2.03571C0.911419 2.14282 0 3.10221 0 4.28568V17.8571C0 19.0406 0.911419 20 2.03571 20H16.9643C18.0886 20 19 19.0406 19 17.8571V4.28568C19 3.10221 18.0886 2.14282 16.9643 2.14282ZM17.6428 17.7676C17.6428 18.2115 17.339 18.5714 16.9642 18.5714H2.03571C1.66093 18.5714 1.35713 18.2115 1.35713 17.7676V7.31828H17.6428V17.7676Z",
    fill: "#B0BBBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2044 8.75195H11.4033V12.503H15.2044V8.75195Z",
    fill: "#B0BBBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconDates);
export default __webpack_public_path__ + "static/media/calendar-icon-dates.0cf89f13a0c7fea94d029751787768ec.svg";
export { ForwardRef as ReactComponent };